export default __webpack_public_path__ + "static/newspaper-0d7fda9aca289fc7a47c11066e32c3a0.svg";